
import React from 'react';
import { cn } from '@/lib/utils';
import { useSidebar } from './context'; // Import useSidebar from the new context file

export interface SidebarProps extends React.HTMLAttributes<HTMLDivElement> {
  collapsible?: boolean;
}

export const Sidebar = React.forwardRef<HTMLDivElement, SidebarProps>(
  ({ className, children, collapsible = false, ...props }, ref) => {
    const { collapsed, collapsedWidth } = useSidebar();
    
    const sidebarWidthClass = collapsible && collapsed ? `w-${collapsedWidth / 4}` : 'w-64'; // Assuming Tailwind's default spacing scale

    return (
      <aside
        ref={ref}
        className={cn(
          'flex flex-col h-full border-r bg-background transition-all duration-300 ease-in-out',
          collapsible ? sidebarWidthClass : 'w-64', // Apply dynamic width if collapsible
          className
        )}
        {...props}
      >
        {children}
      </aside>
    );
  }
);
Sidebar.displayName = 'Sidebar';
